import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persist'

const pinia = createPinia();

// 数据持久化
pinia.use(piniaPersist);

export default pinia